<h2 mat-dialog-title>Multi-area non disponibile.</h2>
<mat-dialog-content class="mat-typography">

  <p style="width: 350px;">La funzionalità multi-area non è disponibile per i Servizi Geolocalizzati. Per selezionare una nuova area deselezionare prima quella scelta.</p>
  
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-stroked-button mat-dialog-close cdkFocusInitial>Ok</button>
</mat-dialog-actions>